module.exports = __webpack_public_path__ + "img/15_36.be572ac6.png";